import { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../../lib/api';
import findMessage from '../../utils/messages'; // Helper function defined below

import LoginRightWrapper from '../../components/common/LoginRightWrapper';
import LoginLeftSide from '../../components/common/LoginLeftSide';
import LoginFooter from '../../components/common/LoginFooter';
import NormalButton from '../../components/common/NormalButton';
import Inputbox from '../../components/common/Inputbox';

export default function EmailVerify() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [errorEmail, setErrorEmail] = useState('');
  const [isEmail, setIsEmail] = useState(false);

  const [verifyCode, setVerifyCode] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef([]);
  const [errorMessage, setErrormessage] = useState('');
  const [resendTimer, setResendTimer] = useState(0); // 60 seconds
  useEffect(() => {
    if (resendTimer <= 0) return;

    const interval = setInterval(() => {
      setResendTimer((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(interval); // cleanup
  }, [resendTimer]);
  const isValidEmail = () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const onInputVerifyCode = (index, value) => {
    if (!/^\d?$/.test(value)) return; // allow only one digit

    const updated = [...verifyCode];
    updated[index] = value;
    setVerifyCode(updated);

    // Move to next input if value is entered
    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    // Move to previous input if value is entered
    if (!value && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const onConfirmEmailVerify = async () => {
    if (!isFullInputed()) return;
    await API.post('user/verifyEmailWithCode', {
      toEmail: email,
      verifyCode: verifyCode.join(''),
    })
      .then((res) => {
        localStorage.setItem('verifyToken', res.data.token);
        navigate('/forgotPassword/reset');
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err?.message;
        console.log('err: ', msg);
        setErrormessage(findMessage(msg));
      });
  };
  const onSendVerifyCode = async () => {
    console.log('onSendVerifyCode');

    await API.post('user/sendVerificationCodeByEmail', {
      toEmail: email,
    })
      .then((res) => {
        setErrorEmail('');
        setIsEmail(true);
        setResendTimer(59);
        console.log('res: ', res.data);
      })
      .catch((err) => {
        console.log('err: ', err);
        const msg = err?.response?.data.message || err.message;
        setErrorEmail(findMessage(msg));
      });
  };
  const onGoToPage = (path) => {
    if (isEmail) setIsEmail(false);
    else navigate(path);
  };
  const isFullInputed = () => {
    return verifyCode.every((val) => val !== '');
  };

  return (
    <div className="relative flex min-h-screen">
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        {/* Modal content with exact size */}
        <div className="relative z-10 bg-white rounded-2xl shadow-xl w-[1044px] h-[700px] overflow-hidden">
          <div className="flex flex-col md:flex-row w-full h-full">
            {/* Left Side - Image */}
            <LoginLeftSide />

            {/* Right Side - Form */}
            <div className="w-full h-full flex flex-col justify-between md:w-1/2 p-10 bg-[#F9F9F9]">
              <LoginRightWrapper
                onGoToPage={(path) => onGoToPage(path)}
                backPath="/login"
              />

              <div className="h-80">
                <div className="space-y-8 font-[poppins] font-semibold pl-0 pr-0 md:pl-14 md:pr-14">
                  <div className="space-y-4">
                    <h2 className="text-xl text-[#333333] font-bold leading-[20px] tracking-[0%]">
                      {isEmail
                        ? 'Recuperar contraseña'
                        : 'Ingresa tu correo el ectrónico'}
                    </h2>
                    <div className="text-sm text-[#717680] font-normal leading-[20px] tracking-[0%]">
                      {isEmail ? (
                        <>
                          <p>
                            Enviamos un código al correo{' '}
                            <span className="font-semibold">{email}</span>
                          </p>
                          <p>Ingresalo a continuación para poder contiuar.</p>
                        </>
                      ) : (
                        <p>
                          Lo utilizaremos para enviarte un código para recuperar
                          tu contraseña.
                        </p>
                      )}
                    </div>
                  </div>

                  {isEmail ? (
                    <div className="w-full space-y-4">
                      <div className="h-12">
                        <div className="h-12 flex items-center justify-between">
                          {verifyCode.map((val, idx) => (
                            <input
                              key={idx}
                              ref={(el) => (inputRefs.current[idx] = el)}
                              type="text"
                              value={val}
                              onChange={(e) =>
                                onInputVerifyCode(idx, e.target.value)
                              }
                              placeholder="_"
                              className={`w-12 h-12 placeholder-[#2A59C6] p-4 rounded-[10px] text-[20px] text-center focus:outline-none focus:border-[#414651] ${
                                errorMessage
                                  ? 'border border-[#f04438] text-[#f04438] bg-[#FEF3F2]'
                                  : isFullInputed()
                                  ? 'border border-[#039855] text-[#039855] bg-[#F9F9F9]'
                                  : 'bg-[#E6EBF7]'
                              }`}
                            />
                          ))}
                        </div>
                      </div>

                      <div className="text-[#f04438] font-[400] text-sm leading-[20px] tracking-[0%]">
                        {errorMessage}
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-1">
                      <Inputbox
                        inputClass="bg-[#FDFDFD]"
                        title="Correo electrónico"
                        titleClass="text-[#424242]"
                        placeholder="ejemplo@mail.com"
                        value={email}
                        onChange={setEmail}
                      />
                      <p className="pl-0.5 text-xs text-[#f04438] font-normal">
                        {errorEmail}
                      </p>
                    </div>
                  )}

                  {isEmail ? (
                    <div className="space-y-2">
                      <NormalButton
                        customClass={`w-full ${
                          isFullInputed()
                            ? 'bg-[#092F7B] text-[#FDFDFD]'
                            : 'bg-[#F5F5F5] text-[#A4A7AE] border border-[#E9EAEB]'
                        }`}
                        text="Continuar"
                        onClick={onConfirmEmailVerify}
                      />

                      <NormalButton
                        disabled={resendTimer ? true : false}
                        customClass="w-full bg-[#E6EBF7] text-[#092F7B]"
                        text={`Reenviar en 00:${
                          resendTimer < 10 ? '0' + resendTimer : resendTimer
                        }`}
                        onClick={onSendVerifyCode}
                      />
                    </div>
                  ) : (
                    <NormalButton
                      customClass={`w-full ${
                        isValidEmail()
                          ? 'bg-[#092F7B] text-white'
                          : 'bg-[#F5F5F5] text-[#A4A7AE] border border-[#E9EAEB]'
                      }`}
                      text="Continuar"
                      onClick={onSendVerifyCode}
                    />
                  )}
                </div>
              </div>

              {/* Login footer */}
              <LoginFooter onClick={() => navigate('/contact')} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
